<template>
  <div class="custom-ui-time-picker-wrapper" v-click-outside="close">
    <div class="time-picker-button" @click="isActive = !isActive">
      <i class="fa-solid fa-clock mr05" />
      <span v-text="time" />
    </div>
    <div class="time-picker-dropdown" v-if="isActive" @click.stop>
      <div class="title" v-text="t('admin_global_settime')" />
      <div class="set-time">
        <span
          class="time-item"
          :class="selected == 0 ? 'active' : ''"
          @click="selected = 0"
          v-text="time[0]"
        />
        <span
          class="time-item"
          :class="selected == 1 ? 'active' : ''"
          @click="selected = 1"
          v-text="time[1]"
        />
        :
        <span
          class="time-item"
          :class="selected == 3 ? 'active' : ''"
          @click="selected = 3"
          v-text="time[3]"
        />
        <span
          class="time-item"
          :class="selected == 4 ? 'active' : ''"
          @click="selected = 4"
          v-text="time[4]"
        />
      </div>
      <div class="digits">
        <span
          class="digit"
          v-for="i in digitList"
          :key="i.time + 'active'"
          :class="i.active ? 'active-digit' : 'inactive-digit'"
          @click="setTime(i)"
          v-text="i.time"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { UseI18n } from '@/utils-ts'
  import { computed, onMounted, ref, watch } from 'vue'

  const { t } = UseI18n()

  const model = defineModel<Date | string>()

  const time = ref<string>('')
  const isActive = ref<boolean>(false)
  const selected = ref<number>(1)

  const digitList = computed(() => [
    {
      time: 0,
      active: true,
    },
    {
      time: 1,
      active: true,
    },
    {
      time: 2,
      active: true,
    },
    {
      time: 3,
      active: true,
    },
    {
      time: 4,
      active: true,
    },
    {
      time: 5,
      active: true,
    },
    {
      time: 6,
      active: true,
    },
    {
      time: 7,
      active: true,
    },
    {
      time: 8,
      active: true,
    },
    {
      time: 9,
      active: true,
    },
  ])

  onMounted(() => convertTime())

  watch(time, val => {
    const [hour, minute] = val.split(':')
    const now = new Date()
    now.setHours(Number(hour))
    now.setMinutes(Number(minute))
    model.value = now
  })

  watch(model, () => {
    convertTime()
  })

  const setTime = (i: { time: number; active: boolean }) => {
    if (!i.active) return
    const hours = time.value.substring(0, selected.value)
    const minutes = time.value.substring(selected.value + 1)
    time.value = `${hours}${i.time}${minutes}`
  }

  const close = () => {
    isActive.value = false
  }

  const convertTime = () => {
    const now = model.value == null ? new Date() : new Date(model.value)
    const hours = String(now.getHours()).padStart(2, '0')
    const minutes = String(now.getMinutes()).padStart(2, '0')
    time.value = `${hours}:${minutes}`
  }
</script>

<style lang="scss" scoped>
  .custom-ui-time-picker-wrapper {
    @include flexible($justify: center, $align: center);
    position: relative;
    .time-picker-button {
      @include flexible($justify: center, $align: center);
      padding: 0.5rem;
      height: 40px;
      border: 1px solid $border-color;
      border-radius: 5px;
      cursor: pointer;
      i {
        color: $brandColor;
      }
    }
    .time-picker-dropdown {
      position: absolute;
      z-index: 9990;
      border-radius: 5px;
      top: 100%;
      width: 250px;
      @include flexible($direction: column, $align: center);
      overflow: hidden;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
      background-color: $white;
      .title {
        color: $white;
        width: 100%;
        padding: 0.5rem;
        text-align: center;
        background-color: $brandColor;
      }
      .set-time {
        background-color: $brandColorLight;
        width: 100%;
        font-size: 2rem;
        color: $white;
        @include flexible($justify: center, $align: center);

        .time-item {
          @include flexible($justify: center, $align: center);
          padding: 0.25rem 0.5rem;
          cursor: pointer;

          &.active {
            background-color: $brandColor;
          }
        }
      }
      .digits {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        background-color: $white;
        .digit {
          width: 33.33%;
          padding: 0.5rem;
          text-align: center;
          cursor: pointer;
          &.active-digit {
            color: $brandColor;
            &:hover {
              background-color: $brandColorLight;
              color: $white;
            }
          }
          &.inactive-digit {
            color: $disabled;
            cursor: default;
          }
        }
      }
    }
  }
</style>
